import React from 'react';
import * as S from './DealRoomSection.styles';
import { Typography } from 'antd';

const { Title, Paragraph, Link } = Typography;

export const ElectricChargingStation: React.FC = () => {
  return (
    <S.Wrapper>
      <S.ContentTextWrapper>
        <Title level={2} className="main-title regular">{`להלן המלצות כלליות לעניין עמדת טעינה בבית משותף:`}</Title>
        <Paragraph className="sub-text mt-16">{`עמדות הטעינה לרוב אינם רכוש משותף (למרות שלרוב מקבל את החשמל מהלוח הראשי של הבניין),
זה רכוש פרטי של הדייר שמתקין עמדה, בדיוק כמו מחסן שנמצא בקומת חניון תת-קרקעי, זה נמצא ברכוש המשותף אבל שייך לדייר.
ככל שהנזק מקורו בנקודת ההטענה – האחריות על הדייר (מומלץ לו לוודא שיש לו כיסוי לעמדת טעינה וגם שהחברה המתקינה מבטחת)
ככל שהנזק מקורו בלוח החשמל ואין לו קשר לנקודת ההטענה – האחריות יכולה להיות של הבניין ובשביל זה חשוב לעשות ביטוח לרכוש המשותף.
`}</Paragraph>
        <Paragraph className="sub-text mt-16">{`בכל מקרה, מומלץ לועד לדרוש ולוודא כי העמדה תותקן בהתאם לכל דרישות החוק ובמידה ונדרש אישור כלשהו (נניח חשמלאי מוסמך) הרי שייתנו אישור כזה.`}</Paragraph>
        <Paragraph className="sub-text mt-16">{`כמו כן מומלץ לועד לוודא כי לדייר יש ביטוח צד ג' לעמדת טעינה שלו (המלצתנו 2 מיליון גבולות אחריות לפחות, עקרונית כמה שיותר יותר טוב כמובן) זאת כדי שאם הוא יגרום נזק לבניין יהיה לכם את מי לחזור ולתבוע ובנוסף אם ייגרם נזקים למשל לרכבים אחרים מהעמדה של הדייר אז יהיה לדיירים את מי לתבוע (כדאי גם כמובן ביטוח צד ג' לרכב עצמו כי הנזק יכול לנבוע מסוללות הרכב ולא רק מהעמדה...).`}</Paragraph>
        <Paragraph className="sub-text mt-16">{`חשוב לציין כי המלצות אלו בסופו של דבר גם יגנו על הדייר עצמו, דייר שלא עושה לעצמנו לביטוח אז בסוף, בשורה התחתונה, משאיר את עצמו הכי חשוף בעת נזק.`}</Paragraph>
      </S.ContentTextWrapper>
      <S.ContentTextWrapper className="mt-16">
        <Title
          level={2}
          className="main-title regular mt-16"
        >{`בנוסף, הדייר נדרש לנקוט באמצעים הבאים להקלת הסיכון כדי לצמצם חשיפה של נזק לבניין:`}</Title>
        <S.ListWrapper>
          <S.ListItem>{`עמדת ההטענה מותקנת בהתאם לתקנים ולהנחיות של רשות החשמל בישראל המתעדכנות מעת לעת.`}</S.ListItem>
          <S.ListItem>{`תשתית החשמל המשמשת את עמדת ההטענה, מתאימה ותומכת בסוג ההטענה המתאים לדגם הרכב לרבות התאמתה לסוג החיבור הקיים בדגם הרכב המוטען.`}</S.ListItem>
          <S.ListItem>{`שקע הטעינה הותקן ע"י חשמלאי מוסמך לפי תקני החשמל המקובלים כולל החיווט אליו, ובהתאמה למתח החשמל הנדרש להטענת סוללת הרכב בהתאם להוראות יצרן הרכב.`}</S.ListItem>
          <S.ListItem>{`הטענת הרכב נעשית אך ורק באמצעות כבלי הטענה מקוריים שסופקו על ידי היצרן ומותאמים לסוג הרכב המוטען.`}</S.ListItem>
          <S.ListItem>{`סוללת הרכב המוטען הינה סוללה מקורית שיוצרה על ידי יצרן הרכב ומותאמת לקבל את מתח החשמל המסופק על ידי תשתית החשמל הביתית.`}</S.ListItem>
          <S.ListItem>{`בסיום טעינת הסוללה יש לנתק את כבלי הטעינה מהסוללה ומעמדת ההטענה.`}</S.ListItem>
          <S.ListItem>{`בלוח החשמל קיים מפסק אוטומטי נפרד, ייעודי לעמדת ההטענה, המנתק את זרם החשמל אל עמדת ההטענה וממנה, בכל מקרה של התחממות יתר של מערכת החשמל, מתח יתר, קצר וכד'.`}</S.ListItem>
          <S.ListItem>{`מטף כיבוי אש אבקה - 6 ק"ג, הכולל התקן מד לחץ המאפשר בדיקת תקינות חזותית של המטפה, יוצב במקום נגיש בסמוך לעמדת ההטענה באופן שיאפשר את הפעלתו המידית במקרה של דליקה.`}</S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
      <S.ContentTextWrapper className="mt-16">
        <Paragraph className="sub-text mt-16">{`מצ"ב מידעון שלנו בנושא הכולל קישור לחוזה שהסוכנות שילמה כסף למשרד עו"ד שיכתוב עבורנו אותו הועד יכול להחתים דייר שרוצה להתקין עמדה (זה גם פתוח בוורד אם תרצו לבצע שינויים בחוזה).`}</Paragraph>
        <Paragraph className="sub-text mt-16">{`אנו ממליצים גם להאזין גם לפודקאסט שלנו על עמדות טעינה.`}</Paragraph>
        <Link
          className="link mt-16"
          target="_blank"
          href="https://open.spotify.com/show/3L9Wbxhxw5y8ueatkBXoPR"
        >{`לחץ להאזנה`}</Link>
        <Paragraph className="sub-text mt-16">{`ולסיום – מצ"ב קישור לכתבה בה מפרטים כי יש תקדים כבר אצל המפקח על המקרקעין שלדרוש מדייר לעשות ביטוח צד ג' לעמדת טעינה זה דרישה לגיטימית וסבירה.`}</Paragraph>
        <Link
          className="link mt-16"
          target="_blank"
          href="https://www.globes.co.il/news/article.aspx?did=1001404641"
        >{`לחץ לקריאת הכתבה בגלובס`}</Link>
      </S.ContentTextWrapper>
    </S.Wrapper>
  );
};
